module.exports = __webpack_public_path__ + "img/tokens_bg.5347088a.png";